<div class="ui-g-12">
  <div class="campaigncharts" *ngIf="data != null">

    <div class="ui-g">
      <div *ngFor="let indicator of indicators" class="ui-g-3 ui-md-3 ui-sm-6 ui-xs-12">
        <app-infobox [pointData]="indicator.pointData" [options]="indicator.options"></app-infobox>
      </div>
    </div>

    <div class="ui-g-12 ui-md-8 ui-sm-12">
      <h2>{{ this.translations.segmentDistributionChartTitle }}</h2>
      <div class="chart-container">
        <chart [options]="segmentDistribution.options" (load)="setChartInstance(segmentDistribution, $event.context)"></chart>
      </div>
    </div>

    <div class="ui-g-12 ui-md-4 ui-sm-12">
      <h2>{{ this.translations.penetrationLoyaltyChartTitle }}</h2>
      <div class="chart-container">
        <chart [options]="penetrationLoyalty.options" (load)="setChartInstance(penetrationLoyalty, $event.context)"></chart>
      </div>
    </div>


  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/list-customer-value/list-customer-value.component.html